import React, { useRef } from "react";

function PostProcessPreview({ imageFile, width, filename, lineSpacing = "0px" }) {
  const completeSound = useRef(new Audio("/egg_loading/ring.mp3"));
  completeSound.current.play();
  if (!imageFile || !filename) return null; // ✅ Don't render if no files are provided
  const previewUrl = URL.createObjectURL(imageFile); // ✅ Create preview URL

  return (
    <div style={{ ...styles.container, width: `${width}px` }}>
      {/* ✅ Centered Title */}
      <h3 style={styles.title}>Previous Selected Files</h3>

      {/* ✅ Left-Aligned File List */}
      <div style={{ ...styles.fileList, gap: lineSpacing }}>
        <p style={styles.filename}>• {filename}</p>
        <p style={styles.filename}>• {imageFile.name}</p>
      </div>

      {/* ✅ Centered Image Preview */}
      <img src={previewUrl} alt="Preview" style={styles.image} />
    </div>
  );
}

const styles = {
    container: {
      backgroundColor: "#fff",
      borderRadius: "10px",
      padding: "15px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: "8px", // ✅ Small gap between title and list
    },
    title: {
      fontSize: "16px",
      fontWeight: "bold",
      color: "#222",
      marginBottom: "8px",
    },
    fileList: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      width: "100%",
      paddingLeft: "60px",
      lineHeight: "1.0", // ✅ Tightest line spacing possible
      gap: "0px", // ✅ No extra spacing between lines
    },
    filename: {
      fontSize: "14px",
      fontWeight: "bold",
      color: "#333",
      wordBreak: "break-word",
      margin: "2px 0", // ✅ Smallest margin to keep spacing minimal
    },
    image: {
        alignSelf: "center", // ✅ Image stays centered
        maxWidth: "100%",
        maxHeight: "120px", // ✅ Small preview size
        borderRadius: "5px",
        objectFit: "contain",
      },
  };

export default PostProcessPreview;
